import { useStore } from './state/store';
import { StatusBar } from './ui/StatusBar';
import { Chat } from './ui/Chat';
import { Dashboard } from './ui/Dashboard';
import { ContextInspector } from './ui/ContextInspector';
import { SettingsPanel } from './ui/SettingsPanel';

const TABS: { id: 'chat' | 'dashboard' | 'context' | 'settings'; label: string }[] = [
  { id: 'chat', label: 'Chat' },
  { id: 'dashboard', label: 'Dashboard' },
  { id: 'context', label: 'Context' },
  { id: 'settings', label: 'Settings' },
];

export function App() {
  const tab = useStore((s) => s.tab);
  const setTab = useStore((s) => s.setTab);
  return (
    <div className="app">
      <header className="topbar">
        <div className="brand">
          LegalAI: Voice <span className="sub">legal case workspace · demo</span>
        </div>
        <nav className="tabs">
          {TABS.map((t) => (
            <button key={t.id} className={tab === t.id ? 'tab active' : 'tab'} onClick={() => setTab(t.id)}>
              {t.label}
            </button>
          ))}
        </nav>
      </header>
      <StatusBar />
      <main className="content">
        {tab === 'chat' && <Chat />}
        {tab === 'dashboard' && <Dashboard />}
        {tab === 'context' && <ContextInspector />}
        {tab === 'settings' && <SettingsPanel />}
      </main>
    </div>
  );
}
